import { render, staticRenderFns } from "./WeixinApiSetting.vue?vue&type=template&id=12aa5d98&scoped=true&"
import script from "./WeixinApiSetting.vue?vue&type=script&lang=ts&"
export * from "./WeixinApiSetting.vue?vue&type=script&lang=ts&"
import style0 from "./WeixinApiSetting.vue?vue&type=style&index=0&id=12aa5d98&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12aa5d98",
  null
  
)

export default component.exports